/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppEnablementDto } from './AppEnablementDto';
import {
    AppEnablementDtoFromJSON,
    AppEnablementDtoFromJSONTyped,
    AppEnablementDtoToJSON,
    AppEnablementDtoToJSONTyped,
} from './AppEnablementDto';

/**
 * 
 * @export
 * @interface EditPaymentMethodAppEnablementForLocationDto
 */
export interface EditPaymentMethodAppEnablementForLocationDto {
    /**
     * 
     * @type {Array<AppEnablementDto>}
     * @memberof EditPaymentMethodAppEnablementForLocationDto
     */
    appEnablements: Array<AppEnablementDto>;
    /**
     * 
     * @type {string}
     * @memberof EditPaymentMethodAppEnablementForLocationDto
     */
    authenticatedUserEmail: string;
}

/**
 * Check if a given object implements the EditPaymentMethodAppEnablementForLocationDto interface.
 */
export function instanceOfEditPaymentMethodAppEnablementForLocationDto(value: object): value is EditPaymentMethodAppEnablementForLocationDto {
    if (!('appEnablements' in value) || value['appEnablements'] === undefined) return false;
    if (!('authenticatedUserEmail' in value) || value['authenticatedUserEmail'] === undefined) return false;
    return true;
}

export function EditPaymentMethodAppEnablementForLocationDtoFromJSON(json: any): EditPaymentMethodAppEnablementForLocationDto {
    return EditPaymentMethodAppEnablementForLocationDtoFromJSONTyped(json, false);
}

export function EditPaymentMethodAppEnablementForLocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditPaymentMethodAppEnablementForLocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'appEnablements': ((json['appEnablements'] as Array<any>).map(AppEnablementDtoFromJSON)),
        'authenticatedUserEmail': json['authenticatedUserEmail'],
    };
}

export function EditPaymentMethodAppEnablementForLocationDtoToJSON(json: any): EditPaymentMethodAppEnablementForLocationDto {
    return EditPaymentMethodAppEnablementForLocationDtoToJSONTyped(json, false);
}

export function EditPaymentMethodAppEnablementForLocationDtoToJSONTyped(value?: EditPaymentMethodAppEnablementForLocationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appEnablements': ((value['appEnablements'] as Array<any>).map(AppEnablementDtoToJSON)),
        'authenticatedUserEmail': value['authenticatedUserEmail'],
    };
}

